import React from 'react';
import { BOXLESS, PRINTERLESS_MAIL, MAIL } from '../../constants/returnMethods';

const MethodPreference = ({ method, width, height }) => {
  switch (method) {
    case BOXLESS:
      return (
        <svg
          viewBox="0 0 30 31"
          width={width}
          height={height}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#a)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.544 30.148h10.335c1.656 0 2.981-1.304 2.981-2.934V3.866c0-1.63-1.325-2.935-2.981-2.935H9.544c-1.657 0-2.982 1.304-2.982 2.935v23.348c0 1.63 1.325 2.934 2.982 2.934ZM7.225 3.866c0-1.24 1.06-2.283 2.319-2.283h10.335c1.258 0 2.319 1.044 2.319 2.283v23.348c0 1.239-1.06 2.282-2.32 2.282H9.545c-1.259 0-2.319-1.043-2.319-2.282V3.866Z"
              fill="#000"
            />
            <ellipse cx="14.711" cy="26.561" rx="1.126" ry="1.109" fill="#ECECEC" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.254 26.496c0 .783.662 1.435 1.457 1.435s1.458-.652 1.458-1.435c0-.782-.663-1.434-1.458-1.434-.795 0-1.457.652-1.457 1.434Zm.662.066c0-.457.332-.783.795-.783.464 0 .795.326.795.782 0 .457-.331.783-.795.783-.463 0-.795-.326-.795-.783ZM9.146 14.235h3.909c.199 0 .331-.13.331-.326v-3.848c0-.195-.132-.326-.331-.326H9.146c-.199 0-.331.13-.331.326v3.848c0 .196.132.326.331.326Zm3.578-.652H9.477v-3.196h3.247v3.196Z"
              fill="#000"
            />
            <path
              d="M11.399 12.605h-.53c-.199 0-.332-.13-.332-.326v-.522c0-.195.133-.326.332-.326h.53c.199 0 .331.13.331.326v.522c0 .13-.199.326-.331.326Z"
              fill="#000"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.146 21.344h3.909c.199 0 .331-.13.331-.326V17.17c0-.195-.132-.326-.331-.326H9.146c-.199 0-.331.13-.331.326v3.848c0 .196.132.326.331.326Zm3.578-.652H9.477v-3.196h3.247v3.196Z"
              fill="#000"
            />
            <path
              d="M11.399 19.714h-.53c-.199 0-.332-.13-.332-.326v-.522c0-.195.133-.326.332-.326h.53c.199 0 .331.13.331.326v.522c0 .195-.199.326-.331.326Z"
              fill="#000"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.367 14.235h3.91c.198 0 .33-.13.33-.326v-3.848c0-.195-.132-.326-.33-.326h-3.91c-.198 0-.33.13-.33.326v3.848c0 .196.132.326.33.326Zm3.578-.652h-3.246v-3.196h3.246v3.196Z"
              fill="#000"
            />
            <path
              d="M18.62 12.605h-.53c-.199 0-.331-.13-.331-.326v-.522c0-.195.132-.326.331-.326h.53c.199 0 .331.13.331.326v.522c0 .13-.132.326-.331.326ZM14.711 18.083c-.199 0-.331-.13-.331-.326v-1.891h-4.107c-.2 0-.332-.13-.332-.326s.133-.326.332-.326h4.438c.199 0 .332.13.332.326v2.217c0 .196-.133.326-.332.326ZM14.711 10.91c-.199 0-.331-.131-.331-.327v-.522c0-.195.132-.326.331-.326s.332.13.332.326v.522c0 .196-.133.326-.332.326ZM14.711 14.236c-.199 0-.331-.13-.331-.326v-1.63c0-.196.132-.327.331-.327s.332.13.332.326v1.63c0 .196-.133.327-.332.327ZM18.09 19.714h-1.656c-.199 0-.332-.13-.332-.326s.133-.326.332-.326h1.325v-.196c0-.195.132-.326.331-.326s.331.13.331.326v.522c0 .195-.198.326-.331.326ZM20.276 21.344h-2.252c-.199 0-.332-.13-.332-.326 0-.195.133-.326.332-.326h1.921V18.28c0-.195.133-.326.331-.326.199 0 .332.13.332.326v2.74c0 .195-.133.325-.332.325ZM16.367 3.8H12.99c-.199 0-.332-.13-.332-.325 0-.196.133-.327.332-.327h3.378c.2 0 .332.13.332.327 0 .195-.133.326-.332.326ZM16.367 21.344h-1.656c-.199 0-.331-.13-.331-.326v-1.63c0-.196.132-.327.331-.327s.332.131.332.327v1.304h1.325c.198 0 .33.13.33.326s-.132.326-.33.326Z"
              fill="#000"
            />
            <path fill="#ECECEC" d="M16.368 15.54h1.656v1.63h-1.656z" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.434 17.497h1.656c.133 0 .331-.131.331-.327v-1.63c0-.196-.132-.326-.331-.326h-1.656c-.199 0-.332.13-.332.326v1.63c0 .196.133.326.332.326Zm1.258-.653H16.7v-.978h.993v.978Z"
              fill="#000"
            />
            <path
              d="M20.276 16.975c-.198 0-.331-.13-.331-.326v-.783h-.199c-.198 0-.331-.13-.331-.326s.133-.326.331-.326h.53c.199 0 .332.13.332.326v1.109c0 .195-.133.326-.332.326Z"
              fill="#000"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M6.563.475h16.563v30H6.561z" />
            </clipPath>
          </defs>
        </svg>
      );

    case PRINTERLESS_MAIL:
      return (
        <svg
          viewBox="0 0 31 31"
          width={width}
          height={height}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.012 26.254c0 .28-.235.508-.524.508h-7.232l.001-2.81v-.031a.895.895 0 0 0-.904-.886h-4.776a.896.896 0 0 0-.904.886v2.84H3.26a.517.517 0 0 1-.525-.507V10.612h7.938v2.643c0 .47.406.851.904.851h4.776c.498 0 .903-.382.903-.85l-.001-2.644h7.757v15.642Zm-8.491.508h-5.112v-2.81c0-.096.076-.174.168-.174h4.777a.17.17 0 0 1 .167.172v2.812ZM6.345 3.367a.338.338 0 0 1 .295-.177l4.878-.002-.805 6.711h-7.75l3.382-6.532Zm10.176 7.245v2.643c0 .076-.076.139-.168.139h-4.776c-.093 0-.168-.063-.168-.139l-.002-2.643h5.114Zm-.771-6.74.727 6.027h-5.023l.805-6.711 3.409.003.082.68Zm5.327-.674c.129 0 .245.069.303.182l3.402 6.52h-7.565l-.808-6.706 4.668.004Zm4.631 6.897L22.037 3.06a1.071 1.071 0 0 0-.959-.575l-4.755-.004V2.48l-4.392-.005h-.328l-4.965.002a1.076 1.076 0 0 0-.947.565l-3.653 7.054a.35.35 0 0 0-.038.16v15.998c0 .673.565 1.22 1.26 1.22h21.228c.694 0 1.26-.547 1.26-1.22V10.256a.35.35 0 0 0-.04-.161Z"
            fill="#000"
          />
          <path
            d="M30.866 18.557a5.599 5.599 0 1 1-11.197 0 5.599 5.599 0 0 1 11.197 0Z"
            fill="#fff"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.267 23.516a4.959 4.959 0 1 0 0-9.918 4.959 4.959 0 0 0 0 9.918Zm0 .64a5.599 5.599 0 1 0 0-11.198 5.599 5.599 0 0 0 0 11.198Z"
            fill="#000"
          />
          <path d="M23.268 16.559h.72v.72h-.72v-.72Z" fill="#000" />
          <path
            d="M24.707 15.839v2.16h-2.159v-2.16h2.16Zm-.36.36h-1.44v1.44h1.44v-1.44ZM23.988 20.158h-.72v.72h.72v-.72Z"
            fill="#000"
          />
          <path
            d="M24.707 19.438v2.16h-2.159v-2.16h2.16Zm-1.8.36v1.44h1.44v-1.44h-1.44ZM26.867 16.559h.72v.72h-.72v-.72Z"
            fill="#000"
          />
          <path
            d="M26.147 15.839v2.16h2.16v-2.16h-2.16Zm1.8.36v1.44h-1.44v-1.44h1.44ZM25.427 16.199v-.36h.36v.72h-.36v.72h-.36v-1.08h.36Z"
            fill="#000"
          />
          <path
            d="M25.427 17.998v-.72h.36v.72h-.36ZM24.707 18.718v-.36h.36v-.36h.36v.72h.36v-.36h1.8v.36h-1.44v.36h-1.08v-.36h-.36Z"
            fill="#000"
          />
          <path
            d="M24.707 18.718v.36h-1.44v-.36h-.36v.36h-.359v-.72h1.08v.36h1.08ZM28.307 19.078h-.36v-.72h.36v.72ZM27.947 19.078h-.36v.72h.72v-.36h-.36v-.36ZM26.507 19.078h.72v.36h-.36v.36h-.36v-.72ZM27.227 20.158v-.36h-.36v.36h-.36v.36h-.72v.36h1.08v-.72h.36Z"
            fill="#000"
          />
          <path
            d="M27.227 20.158h1.08v.36h-.72v.36h-.36v-.72ZM25.787 19.798v.36h.36v-.72h-1.08v.36h.72ZM25.067 20.158h.36v1.08h1.44v.36h-1.8v-1.44ZM28.307 20.878v.72h-1.08v-.36h.72v-.36h.36Z"
            fill="#000"
          />
        </svg>
      );

    case MAIL:
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 31 31"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.018 23.302c0 .27-.226.488-.504.488h-6.942v-2.727a.86.86 0 0 0-.867-.85H11.12a.86.86 0 0 0-.868.85v2.727H3.135a.496.496 0 0 1-.503-.488V8.287h7.62v2.537c0 .45.39.817.868.817h4.585c.478 0 .867-.367.867-.817l-.002-2.537h7.448v15.015Zm-8.152.488h-4.908v-2.697c0-.092.073-.167.162-.167h4.586c.088 0 .159.074.16.165v2.7ZM6.097 1.33a.325.325 0 0 1 .284-.168l4.682-.003-.772 6.443H2.85l3.246-6.271Zm9.77 6.957v2.537c0 .073-.073.133-.162.133H11.12c-.09 0-.162-.06-.162-.133l-.001-2.537h4.91Zm-.741-6.471.697 5.786h-4.821l.773-6.443 3.272.004.079.653Zm5.114-.647c.124 0 .235.066.29.175l3.267 6.258h-7.263l-.776-6.437 4.482.004Zm4.446 6.621-3.524-6.754a1.028 1.028 0 0 0-.92-.552L15.675.481V.48L11.46.475h-.315L6.378.477c-.382.003-.73.209-.909.542L1.963 7.791a.336.336 0 0 0-.037.153v15.359c0 .646.542 1.172 1.21 1.172h20.378c.667 0 1.21-.526 1.21-1.172V7.944a.335.335 0 0 0-.038-.154Z"
            fill="#000"
          />
          <path
            d="M17.897 11.84c0-.68.55-1.23 1.229-1.23h10.442c.679 0 1.229.55 1.229 1.23v5.835c0 .678-.55 1.229-1.229 1.229H19.127c-.679 0-1.229-.55-1.229-1.229v-5.836Z"
            fill="#fff"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.569 11.225H19.126a.614.614 0 0 0-.614.614v5.836c0 .34.274.614.614.614h10.442c.34 0 .615-.275.615-.614v-5.836a.614.614 0 0 0-.614-.614Zm-10.443-.614c-.679 0-1.229.55-1.229 1.228v5.836c0 .678.55 1.229 1.229 1.229h10.442c.679 0 1.229-.55 1.229-1.229v-5.836c0-.678-.55-1.228-1.229-1.228H19.127Z"
            fill="#000"
          />
          <path
            d="M20.047 12.914a.46.46 0 0 1 .46-.46h3.072a.46.46 0 1 1 0 .92h-3.071a.46.46 0 0 1-.46-.46ZM20.047 14.755a.46.46 0 0 1 .46-.46h7.986a.46.46 0 1 1 0 .92h-7.985a.46.46 0 0 1-.46-.46ZM20.047 16.6a.46.46 0 0 1 .46-.46h7.986a.46.46 0 1 1 0 .922h-7.985a.46.46 0 0 1-.46-.461Z"
            fill="#000"
          />
        </svg>
      );

    default:
      return null;
  }
};

export default MethodPreference;
